import React from 'react';

import { MaterialPropertyValuePair } from '@paragon/client-tools';
import { PropertiesPanel } from '@paragon/layout-models';

import { getSingleSelectedItemEntryOrNull } from '../../../../store/selectors/getSelectedItemSelector';
import { useAppSelector } from '../../../hooks';

export function SpliceProperties() {
  const selectedEntry = useAppSelector(getSingleSelectedItemEntryOrNull);

  if (selectedEntry?.type !== 'splice') return null;

  return (
    <PropertiesPanel title="Splice Properties">
      <MaterialPropertyValuePair property="Name" value={selectedEntry.item.name} />
    </PropertiesPanel>
  );
}
